import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=4f07b598&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "./Settings.vue?vue&type=style&index=0&id=4f07b598&prod&lang=css"
import style1 from "./Settings.vue?vue&type=style&index=1&id=4f07b598&prod&lang=scss&scoped=true"
import style2 from "./Settings.vue?vue&type=style&index=2&id=4f07b598&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f07b598",
  null
  
)

export default component.exports